// @ts-nocheck
// ====== Import CSV per Risorse e Ruoli ======
// Estende l'import dei clienti (`js/ui/import-clienti.js`) con:
//   - Risorse: CSV con colonna `nome`
//   - Ruoli:   CSV con colonne `nome,perimetro,descrizione,attivo`

// Parser CSV minimal, supporta valori quoted e separatore virgola.
function parseCsvSimple(text) {
  const rows = [];
  let cur = '';
  let row = [];
  let inQuotes = false;
  const flush = () => {
    row.push(cur);
    cur = '';
  };
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"' && text[i + 1] === '"') {
        cur += '"';
        i++;
      } else if (ch === '"') inQuotes = false;
      else cur += ch;
    } else {
      if (ch === '"') inQuotes = true;
      else if (ch === ',') flush();
      else if (ch === '\r') {
      } else if (ch === '\n') {
        flush();
        rows.push(row);
        row = [];
      } else cur += ch;
    }
  }
  if (cur.length || row.length) {
    flush();
    rows.push(row);
  }
  return rows.filter((r) => r.length > 1 || (r.length === 1 && r[0]));
}

function toRecords(rows) {
  if (!rows.length) return [];
  const header = rows[0].map((h) => h.trim().toLowerCase());
  return rows.slice(1).map((r) => {
    const obj = {};
    header.forEach((h, i) => (obj[h] = (r[i] ?? '').trim()));
    return obj;
  });
}

// ===== Risorse =====
async function importRisorse(file) {
  if (!isAdmin()) return;
  const text = await file.text();
  const records = toRecords(parseCsvSimple(text));
  const newNames = records.map((r) => r.nome).filter(Boolean);
  if (!newNames.length) {
    toast('Nessun nome valido trovato (colonna "nome" attesa)');
    return;
  }
  const existing = new Set(state.resources.map((r) => r.toLowerCase()));
  const toAdd = newNames.filter((n) => !existing.has(n.toLowerCase()));
  if (!toAdd.length) {
    toast(`Nessuna nuova risorsa (tutte ${newNames.length} già presenti)`);
    return;
  }
  const ok = await confirmAction({
    level: 'info',
    title: 'Importare risorse',
    message: `Stai per aggiungere ${toAdd.length} risorse al team (${newNames.length - toAdd.length} già esistenti verranno ignorate).`,
    details: toAdd
      .slice(0, 10)
      .concat(toAdd.length > 10 ? ['…e altre ' + (toAdd.length - 10)] : []),
    confirmText: 'Importa'
  });
  if (!ok) return;
  let added = 0;
  for (const nome of toAdd) {
    try {
      await api.addResource(nome);
      added++;
    } catch (e) {
      console.warn('Risorsa skip:', nome, e.message);
    }
  }
  logAudit({
    action: 'create',
    entity: 'Risorsa',
    target: `Import (${added})`,
    details: `${added} risorse importate via CSV`
  });
  await loadStateFromSupabase();
  renderAll();
  toast(`${added} risorse aggiunte`);
}

function downloadTemplateRisorse() {
  const csv = 'nome\nMario Rossi\nLuca Verdi\n';
  downloadFile('template-risorse.csv', csv, 'text/csv');
}

// ===== Ruoli =====
// Schema atteso: nome,perimetro,descrizione,attivo
async function importRuoli(file) {
  if (!isAdmin()) return;
  const text = await file.text();
  const records = toRecords(parseCsvSimple(text));
  const valid = records.filter((r) => (r.nome || '').trim());
  if (!valid.length) {
    toast('Nessun ruolo valido trovato (colonna "nome" attesa)');
    return;
  }
  const ok = await confirmAction({
    level: 'info',
    title: 'Importare ruoli',
    message: `Stai per importare ${valid.length} ruoli nel catalogo (i nomi già esistenti verranno aggiornati).`,
    confirmText: 'Importa'
  });
  if (!ok) return;
  let written = 0;
  for (const r of valid) {
    const payload = {
      nome: (r.nome || '').trim(),
      perimetro: (r.perimetro || '').trim() || null,
      descrizione: (r.descrizione || '').trim() || null,
      attivo: !['no', 'false', '0', 'off'].includes((r.attivo || 'si').toLowerCase())
    };
    try {
      await sb.from('ruoli_catalogo').upsert(payload, { onConflict: 'nome' });
      written++;
    } catch (e) {
      console.warn('Ruolo skip:', r.nome, e.message);
    }
  }
  logAudit({
    action: 'system',
    entity: 'Ruolo',
    target: `Import (${written})`,
    details: `${written} ruoli importati via CSV`
  });
  if (typeof loadRuoliPredefiniti === 'function') await loadRuoliPredefiniti();
  if (typeof renderRuoli === 'function') renderRuoli();
  toast(`${written} ruoli importati`);
}

function downloadTemplateRuoli() {
  const csv =
    'nome,perimetro,descrizione,attivo\n' +
    'Global Administrator,M365,Privilegi completi sul tenant,si\n' +
    'Contributor,Azure,Lettura+scrittura sulle risorse,si\n';
  downloadFile('template-ruoli.csv', csv, 'text/csv');
}

// La vista "ruoli" è lazy: i suoi pulsanti import vanno (ri)wired al mount.
// Idempotente via dataset flag. (Risorse resta inline.)
function wireRuoliImport() {
  const tpl = document.getElementById('btnTemplateRuoli');
  if (tpl && tpl.dataset.wired !== '1') {
    tpl.dataset.wired = '1';
    tpl.addEventListener('click', downloadTemplateRuoli);
  }
  const file = document.getElementById('fileImportRuoli');
  if (file && file.dataset.wired !== '1') {
    file.dataset.wired = '1';
    file.addEventListener('change', async (e) => {
      const f = e.target.files?.[0];
      e.target.value = '';
      if (f) await importRuoli(f);
    });
  }
}

// Vista "risorse" ora lazy: i suoi pulsanti import vanno (ri)wired al mount.
function wireRisorseImport() {
  bindOnce(document.getElementById('btnTemplateRisorse'), 'click', downloadTemplateRisorse);
  bindOnce(document.getElementById('fileImportRisorse'), 'change', async (e) => {
    const f = e.target.files?.[0];
    e.target.value = '';
    if (f) await importRisorse(f);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  wireRisorseImport(); // no-op finché la vista risorse non è montata
  wireRuoliImport(); // no-op se la vista ruoli non è ancora montata
});
globalThis.bus?.on?.('view:lazy-loaded', (p) => {
  if (p && p.viewId === 'ruoli') wireRuoliImport();
  if (p && p.viewId === 'risorse') wireRisorseImport();
});

Object.assign(globalThis, {
  importRisorse,
  importRuoli,
  downloadTemplateRisorse,
  downloadTemplateRuoli
});
export {};
